var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"status-chip",style:({ background: _vm.colorHex })},[_c('span',{staticClass:"aisea-text-12-700-white"},[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }